// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productImageBadgesStyles } from "@synd/Overrides/Components/ProductImageBadges";
import { css } from "styled-components";

productImageBadgesStyles.imageContainer = {
    css: css`
        justify-content: left;
        gap: 2px;
        flex-wrap: wrap;
    `,
};

productImageBadgesStyles.imageItem = {
    css: css`
        flex-basis: unset;
        width: 18px;
        height: 18px;
        max-width: unset;
        & [data-state] {
            display: flex;
            margin-left: 0;
        }
    `,
};
productImageBadgesStyles.badgeImageProps = {
    width: "18px",
    height: "18px",
};
